import { DESCRIBE_MEDICAL_RECORDS_NOTES_WITH_PAGINATION } from './constants';
import { NotesResponse } from './fetchAllMedicalRecordsInADoc';
import fetchWithRefresh from './fetchWithRefresh';

export type MedicalRecordsNotesResponse = NotesResponse;

export default (
    ptId: string,
    document_id: string,
    next_token?: string,
): Promise<MedicalRecordsNotesResponse> =>
    fetchWithRefresh(
        DESCRIBE_MEDICAL_RECORDS_NOTES_WITH_PAGINATION(ptId, document_id, next_token),
    ).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('describe medical records notes failed');
        }
    });
